import { Application, ApplicationConnection, ApplicationPermissionScope } from 'models'

/* Granted codes are labelled from the same list step one showed, so the two steps can never
 * disagree. A code the manifest does not list is shown as it came, making a new backend scope
 * visible rather than silently dropped. */
export const scopeLabel = (scopes: ApplicationPermissionScope[], code: string): string =>
  scopes.find((scope) => scope.code === code)?.label ?? code

/* The sites an ambiguous approval reached, so the admin knows which account to use instead. Each
 * entry is shown by whatever name it carries, since only ticket 07 settles the metadata shape. */
export const ambiguousSites = (connection: ApplicationConnection | undefined): string[] => {
  const sites = connection?.provider_metadata?.sites

  if (!Array.isArray(sites)) return []

  return sites
    .map((site) => (typeof site === 'string' ? site : site?.site_name || site?.site_url || ''))
    .filter(Boolean)
}

/* The completion the callback page handed over against the instance just read back. A read that
 * still says PENDING has not caught up with the approval, and showing it would put the admin back
 * on step one for a moment. */
export const resolveReturnedApplication = (
  fetched: Application | null,
  handedOver: Application | null
): Application | null => {
  if (!fetched) return handedOver
  if (!handedOver || handedOver.id !== fetched.id) return fetched

  const stale = fetched.connection?.status === 'PENDING' && handedOver.connection?.status === 'CONNECTED'

  return stale ? handedOver : fetched
}
